export class GiftCard {
  private _cardNumber: string;
  private _amount: number;
  private _name: string;

  constructor(
    cardNumber: string,
    amount: number,
    name: string,
  ) {
    this._cardNumber = cardNumber;
    this._amount = amount;
    this._name = name;
  }

  static arrayFromJSON(json: string): GiftCard[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: GiftCard[] = [];
    for (const item of values) {
      result.push(GiftCard.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): GiftCard {
    if (object === null || object === undefined) {
      return null;
    }

    return new GiftCard(
      object.cardNumber,
      object.amount,
      object.name,
    );
  }

  static getTotalCardsAmount(cards: GiftCard[]): number {
    if (!cards || !cards.length) {
      return 0;
    }
    return cards.reduce(
      (pv, cv) => pv + cv.amount,
      0
    );
  }

  get cardNumber(): string {
    return this._cardNumber;
  }

  get amount(): number {
    return this._amount;
  }

  set amount(value: number) {
    this._amount = value;
  }

  get name(): string {
    return this._name;
  }

  toJSON(): any {
    return {
      cardNumber: this._cardNumber,
      amount: this._amount,
      name: this.name,
    };
  }
}
